import React, { useContext, useEffect, useRef, useState } from "react";

import Intro from "./Intro";
import CrmRecord from "./CrmRecord";
import EditMatch from "./EditMatch";
import { diffRecordCheckerInCRM } from "../../../apis/ext";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useClickAway } from "@uidotdev/usehooks";
import TooltipWrapper from "../TooltipWrapper";
import UpdateRecord from "./UpdateRecord";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import SharedDataContext from "../../../SharedDataContext";
import { Skeleton } from "../../ui/skeleton";
import { Button } from "../../ui/button";
import Image from "../../Tags/Image";
import GenericModal from "../../GenericModal";
import useModal from "../../GenericModal/useModal";
import { useStoreIntegrations } from "../../../stores/useStoreIntegrations";
import { useCRMGetRecords } from "../../../apiHooks/useCRMGetRecords";
import { useCRMSearchRecords } from "../../../apiHooks/useCRMSearchRecords";
import { useStoreCRMSearch } from "../../../stores/useStoreCRMSearch";
import { useStoreCRMConfig } from "../../../stores/useStoreCRMConfig";
import { matchCRMRecord } from "../../../apis/crm";
import { useStoreCRMAnalyse } from "../../../stores/useStoreCRMAnalyse";
import { useCRMAnalyseRecords } from "../../../apiHooks/useCRMAnalyseRecords";

export default function CRM({
  activeWorkspace,
  activeCrm = "",
  recordData = {},
  type = "",
  className = "mt-4 relative inline-block",
  getCRMPhonesEmails,
  contactRevealed = true,
  companyMiniView = true,
  getActiveCRMID = null,
  isBulkEnrichment = false,
  crmSearchData = [],
  isCRMBulkSearchPending = true,
  source = "",
  contentPosition = "",
}) {
  const {
    savedCRMConfig: crmObjectsConfig,
    savedCompanyConfig,
    savedCompanyConfigObj,
    savedPeopleConfig: personArr,
  } = useStoreCRMConfig();

  const { getCRMAnalyseRecordById, crmBulkAnalyseData } = useStoreCRMAnalyse();
  const { mutate: handleCRMAnalyse, isLoading: isCRMAnalyseLoading } = useCRMAnalyseRecords({
    onStream: (data, variables) => {
      console.log("data chunk in crm analyse", data);
      setDiffData(data?.data);
    },
  });

  const captureEvent = useCaptureEvent();
  const { params } = useContext(SharedDataContext);

  const queryClient = useQueryClient();
  const [updateMode, setUpdateMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [createDirect, setCreateDirect] = useState(false);
  const [filters, setFilters] = useState({});
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [diffData, setDiffData] = useState({});
  const [record, setRecord] = useState([]);
  const [convertedCRMObjectApiName, setConvertedCRMObjectApiName] = useState("");
  const [records, setRecords] = useState([]);
  const [allRecords, setAllRecords] = useState([]);
  const [objectWithSearchFilters, setObjectWithSearchFilters] = useState({});
  const [allRecordsWithApiName, setAllRecordsWithApiName] = useState([]);
  const [allRecordsWithApiNameError, setAllRecordsWithApiNameError] = useState([]);
  const [matchedObj, setMatchedObj] = useState({});
  const [objectLabelName, setObjectLabelName] = useState("");
  const [objectApiName, setObjectApiName] = useState("");
  const handleToggleDropdown = () => {
    setToggleDropdown(!toggleDropdown);
  };

  // check company is in CRM record

  const [crmSearchDataProccessed, setCrmSearchDataProccessed] = useState(false);

  const handleFetchedSearchCRMData = (data = [], variables = {}) => {
    try {
      const copyData = JSON.parse(JSON.stringify(data));
      let obj = {};
      copyData.forEach((item) => {
        const apiName = item.crm_object_api_name;
        obj[apiName] = {
          apiName: item.crm_object_api_name,
          apiNameLabel: item?.crm_object_label,
          search_filters_applied: item?.search_filters_applied,
        };
      });
      // console.log("boj", obj);
      setObjectWithSearchFilters(obj);
    } catch (err) {
      console.log("Unable to set filters");
    }
    if (data[0]?.records && data[0]?.records.length > 0) {
      let records = data[0]?.records;
      setRecords(records);
      setConvertedCRMObjectApiName(data[0]?.converted_crm_object_api_name);
    }

    setAllRecords(data);

    if (!data[0]?.records) {
      setFetchedRecordObj(data[0]?.search_filters_applied);
      setObjectApiName(data[0]?.crm_object_api_name);
      setObjectLabelName(data[0]?.crm_object_label);
    }

    const result = data.flatMap((item) =>
      Array.isArray(item.records) && item.records.length > 0
        ? item.records.map((record) => ({
            ...record,
            apiName: item.crm_object_api_name,
            apiNameLabel: item?.crm_object_label,
            search_filters_applied: item?.search_filters_applied,
          }))
        : []
    );

    const resultWithError = data.filter((item) => item.error);
    console.log("resultWithError", resultWithError);
    setAllRecordsWithApiNameError(resultWithError);
    const matchedObj =
      result && result.length > 0
        ? result
            .filter((obj) => obj.match_confirmed)
            .sort((a, b) => new Date(b.record_created_at) - new Date(a.record_created_at))[0]
        : undefined;

    if (result && result.length > 0) {
      setFetchedRecordObj(result[0]?.search_filters_applied);
    }

    if (matchedObj && matchedObj.match_confirmed) {
      if (crmBulkAnalyseData && crmBulkAnalyseData.length > 0) {
        let foundDiffObj = crmBulkAnalyseData.find((el) => el.crm_record_id === matchedObj?.Id);

        setDiffData(foundDiffObj?.data || {});
      }
      setObjectApiName(matchedObj?.apiName);
      setObjectLabelName(matchedObj?.apiNameLabel);
      // handleFetchRecordInCRM(matchedObj?.apiName);
      setFilters(matchedObj?.search_filters_applied);

      const result = Object.entries(matchedObj?.data).map(([key, innerObj]) => ({
        key,
        label: innerObj?.label ?? "",
        value: innerObj?.value ?? null,
      }));
      setRecord(result);
    } else if (result && result.length === 1) {
      setObjectApiName(result[0]?.apiName);
      setObjectLabelName(result[0]?.apiNameLabel);
      setFilters(result[0]?.search_filters_applied);
    } else {
      console.log("check...");
      setObjectApiName(data[0]?.crm_object_api_name);
      setObjectLabelName(data[0]?.crm_object_label);
    }
    if (variables?.context?.fromFilter) {
      console.log("From filter");
    } else {
      if (getCRMPhonesEmails && matchedObj && matchedObj.match_confirmed) {
        console.log("extractPhonesAndEmails(obj)", extractPhonesAndEmails(matchedObj?.data));
        getCRMPhonesEmails(extractPhonesAndEmails(matchedObj?.data));
      }
      setMatchedObj(matchedObj);
    }
    setAllRecordsWithApiName(result);
    if (!matchedObj && result && result.length > 0) {
      const data = Object.entries(result[0]?.data).map(([key, innerObj]) => ({
        key,
        label: innerObj?.label ?? "",
        value: innerObj?.value ?? null,
      }));

      setRecord(data);
    }
    if (type === "company") {
      setCrmSearchDataProccessed(true);
    }
  };

  const handleCRMBulkAnalyse = (crmBulkAnalysePayload = [], crmConfigId) => {
    if (crmBulkAnalysePayload?.length === 0 || isCRMAnalyseLoading) {
      return;
    }
    console.log("handleCRMBulkAnalyse", { crmBulkAnalysePayload, crmConfigId });
    handleCRMAnalyse({
      data: crmBulkAnalysePayload,
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const { setCRMBulkSearchPayload, isCRMBulkSearchLoading, getCRMSearchRecordById } = useStoreCRMSearch();

  const { mutate: handleCRMSearch, isLoading: isCRMSearchLoading } = useCRMSearchRecords({
    onStream: (data, variables) => {
      console.log("data?.data handleCRMSearch", data?.data);
      handleFetchedSearchCRMData(data?.data, variables);

      if (data?.data && data?.data.length > 0) {
        const flattenedRecords = data?.data.flatMap((item) => item.records);
        const foundObj = flattenedRecords.find((el) => el.match_confirmed);
        let analysePayload = [];
        let obj = {
          type: type,
        };
        if (type === "person") {
          if (recordData.contact_id) {
            obj.contact_id = recordData.contact_id;
          }
          if (recordData.person_id) {
            obj.person_id = recordData.person_id;
          }
        }
        if (type === "company") {
          if (recordData.organization_id || recordData?.id) {
            obj.organization_id = recordData?.id || recordData.organization_id;
          }
        }
        if (foundObj && foundObj.Id) {
          obj.crm_record_id = foundObj.Id;
          analysePayload.push(obj);
        }

        if (analysePayload && analysePayload.length > 0 && activeCrm) {
          handleCRMBulkAnalyse(analysePayload, activeCrm);
        }
      }
    },
  });

  const handleSearchCRMRecords = (name = "", configId, searchParams = null, contactId) => {
    console.log("inside handleSearchCRMRecords");
    if (isCRMSearchLoading) {
      return;
    }

    let payload = [
      {
        organization_id: recordData?.id,
        type: "company",
        search_params: searchParams
          ? searchParams
          : {
              name: name,
              social_media_urls_linkedin_url: recordData?.social_media_urls?.linkedin?.url,
              domain: recordData?.domain,
            },
      },
    ];

    console.log("recordData", recordData);

    if (type === "person") {
      payload = [
        {
          person_id: recordData?.person_id,
          contact_id: contactId ? contactId : recordData.contact_id,
          type: "person",
          reference_organization_id: recordData?.organization_id,
          search_params: searchParams
            ? searchParams
            : {
                last_name: recordData?.last_name,
                company: recordData?.company,
                linkedin_url: recordData?.linkedin_url,
              },
        },
      ];
    }
    if (searchParams) {
      payload[0].edit_search = true;
    } else {
      payload[0].edit_search = false;
      delete payload[0].search_params;
    }

    console.log("crm_search_payload", payload);

    handleCRMSearch({
      data: payload,
      configId: configId,

      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
      context: { fromFilter: searchParams ? true : false },
    });
  };

  const hasSearchedPerson = useRef(false);

  useEffect(() => {
    hasSearchedPerson.current = false;
  }, [recordData?.name]);

  useEffect(() => {
    console.log("recordData in handleSearchCRMRecords", { recordData, crmSearchData, activeCrm, type });
    if (!activeCrm) {
      return;
    }

    if (type === "company") {
      if (isBulkEnrichment) {
        if (Array.isArray(crmSearchData) && crmSearchData.length > 0) {
          handleFetchedSearchCRMData(crmSearchData);
        } else if (!isCRMBulkSearchPending && !crmSearchDataProccessed) {
          setCrmSearchDataProccessed(true);
        }
      } else if (recordData?.name && !crmSearchDataProccessed) {
        handleSearchCRMRecords(recordData?.name, activeCrm);
      }
      return;
    }

    if (recordData?.name && type === "person") {
      console.log("first handleSearchCRMRecords");
      if (crmSearchData.length === 0 && !isCRMBulkSearchPending && !isBulkEnrichment) {
        if (!hasSearchedPerson.current) {
          handleSearchCRMRecords(recordData?.name, activeCrm);
          hasSearchedPerson.current = true;
        }
      } else {
        handleFetchedSearchCRMData(crmSearchData);
      }
    }
  }, [
    recordData?.name,
    activeCrm,
    type,
    isCRMBulkSearchPending,
    crmSearchData,
    crmBulkAnalyseData,
    crmSearchDataProccessed,
    isBulkEnrichment,
  ]);

  useEffect(() => {
    if (recordData?.name && activeCrm) {
      if (typeof window !== "undefined") {
        const handleRunSearch = (event) => {
          console.log("handleRunSearch event", event);
          if (
            recordData?.id === event?.detail?.contact_id ||
            recordData?.id === event?.detail?.person_id
          ) {
            // Deep clone recordData and update with event details
            const updatedRecordData = JSON.parse(JSON.stringify(recordData));
            updatedRecordData.contact_id = event?.detail?.contact_id;
            updatedRecordData.person_id = event?.detail?.person_id;
            
            handleSearchCRMRecords(updatedRecordData?.name, activeCrm, null, updatedRecordData.contact_id);
          }
        };
        window.addEventListener("contact_revealed", handleRunSearch);
        return () => {
          window.removeEventListener("contact_revealed", handleRunSearch);
        };
      }
    }
  }, [recordData?.name, activeCrm, type]);

  // match record
  const [currentRecordId, setCurrentRecordId] = useState("");
  const matchCompanyInCRMFn = useMutation("match_company_in_crm", matchCRMRecord, {
    onSuccess(data, variables, context) {
      handleSearchCRMRecords(recordData?.name, activeCrm);
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleMatchCompanyInCRM = (crmId = "", edit = false, apiName = "") => {
    setCurrentRecordId(crmId);
    const data = {
      crm_object_api_name: apiName ? apiName : objectApiName,
      crm_record_id: crmId,
    };
    if (type === "person") {
      data.person_id = recordData?.person_id;
      if (recordData?.contact_id) {
        data.contact_id = recordData?.contact_id;
      }
      data.type = "person";
    }
    if (type === "company") {
      data.organization_id = recordData?.id;
      data.type = "company";
    }
    // if (edit) {
    //   data.edit_match = true;
    // }
    matchCompanyInCRMFn.mutate({
      data: data,
      configId: activeCrm,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  // fetch record

  const extractPhonesAndEmails = (source) => {
    let crmPhonesEmails = { phone_numbers: [], email_addresses: [] };
    try {
      const emailPattern = /^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w\-+_]+)*\s*$/;
      const phonePattern =
        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{1,4})[-. )]*(\d{1,4})[-. ]*(\d{1,4})(?: *x(\d+))?\s*$/;
      for (let key in source) {
        const { label, value } = source[key];

        // Skip if value is null/undefined/empty string
        if (!value) continue;

        const keyLower = key.toLowerCase();

        // ✅ Check for valid emails (excluding keys with 'record_')
        if (keyLower.includes("email") && !keyLower.includes("record_")) {
          if (emailPattern.test(value)) {
            crmPhonesEmails.email_addresses.push(value.trim());
          }
        }

        // ✅ Check for valid phones (includes mobile/direct/other_phone etc.)
        if (keyLower.includes("phone") || keyLower.includes("mobile") || keyLower.includes("board_line")) {
          if (phonePattern.test(value)) {
            crmPhonesEmails.phone_numbers.push(value.trim());
          }
        }
      }

      return crmPhonesEmails;
    } catch (err) {
      return crmPhonesEmails;
    }
  };

  const [fetchedRecordObj, setFetchedRecordObj] = useState({});
  const [fetchedReferences, setFetchedReferences] = useState([]);

  const getCRMRecordsFn = useCRMGetRecords({
    onSuccess: (resdata) => {
      console.log("CRM records", resdata);
      let data = resdata && resdata.length > 0 && resdata[0];
      if (data && data.references && data.references.length > 0) {
        setFetchedReferences(data.references);
      }
      if (data && data.data) {
        const obj = data.data;

        // if (getCRMPhonesEmails) {
        //   console.log("extractPhonesAndEmails(obj)", extractPhonesAndEmails(obj));
        //   getCRMPhonesEmails(extractPhonesAndEmails(obj));
        // }
        // setFetchedRecordObj(obj);
        const result = Object.keys(obj).map((key) => {
          const innerObject = obj[key]; // Get the inner object
          if (innerObject && typeof innerObject === "object") {
            // Ensure it's a valid object
            const value = Object.values(innerObject)[0]; // Get the first value
            return { key: key, value: value };
          }
          return { key: key, value: null }; // Fallback if no valid inner object
        });

        console.log("result in getCRMRecordsFn", result);

        // setRecord(result);
      }
    },
  });

  const handleFetchRecordInCRM = (apiName = objectApiName) => {
    if (getCRMRecordsFn.isLoading) {
      return;
    }
    console.log("recordData handleFetchRecordInCRM", recordData);
    let payload = {};
    if (type === "person") {
      payload = {
        crm_object_api_name: apiName,
        type: type,
        person_id: recordData?.person_id,
        organization_id: recordData?.organization_id,
        references: [
          {
            type: "company",
            organization_id: recordData?.organization_id,
            search_params: {
              name: recordData?.company,
            },
          },
        ],
      };
    }
    if (type === "company") {
      payload = {
        organization_id: recordData?.id,
        type: type,
        crm_object_api_name: apiName,
      };
    }

    getCRMRecordsFn.mutate({
      data: [{ ...payload }],
      configId: activeCrm,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  //  handle integrations and pref
  const [activeCrmId, setActiveCrmId] = useState(activeCrm);

  const {
    installedCRMIntegrations: installedCrm,
    activeCRMIntegration,
    enabledCRMIntegrations,
  } = useStoreIntegrations();
  useEffect(() => {
    setActiveCrmId(activeCRMIntegration?.id);
  }, [activeCRMIntegration]);

  useEffect(() => {
    console.log("all records", { matchedObj, diffData, record });
  }, [matchedObj, diffData, record]);

  const returnImgAndName = (match = {}, diff = {}, arr = [], errArr) => {
    if (activeCrm) {
      if (errArr && errArr.length > 0) {
        return (
          <>
            <Image src="/images/ext/crm/error.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
            CRM
          </>
        );
      } else {
        if (match && match.match_confirmed && Object.keys(diff).length === 0) {
          return (
            <>
              <Image src="/images/ext/crm/matched.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
              CRM
            </>
          );
        } else if (arr && arr.length > 0 && diffData && Object.keys(diffData).length > 0) {
          return (
            <>
              <Image src="/images/ext/crm/outdated.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
              Needs update
            </>
          );
        } else if (arr && arr.length === 0) {
          return (
            <>
              <Image src="/images/ext/crm/not-allowed.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
              CRM
            </>
          );
        } else if (arr && arr.length > 1) {
          if (type === "company") {
            return (
              <>
                <Image
                  src="/images/ext/crm/company-multiple.svg"
                  className="mr-2 h-[16px] w-[16px] no-invert"
                />
                CRM
              </>
            );
          } else {
            return (
              <>
                <Image
                  src="/images/ext/crm/person-multiple.svg"
                  className="mr-2 h-[16px] w-[16px] no-invert"
                />
                CRM
              </>
            );
          }
        } else if (arr && arr.length === 1 && Object.keys(diff).length === 0) {
          if (arr[0].probable_match) {
            return (
              <>
                <Image src="/images/ext/crm/soft-matched.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
                CRM
              </>
            );
          } else {
            return (
              <>
                <Image src="/images/ext/crm/matched.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
                CRM
              </>
            );
          }
        } else {
          return "CRM";
        }
      }
    } else {
      return "CRM";
    }
  };

  const returnEventState = (match = {}, diff = {}, arr = [], errArr) => {
    if (activeCrm) {
      if (errArr && errArr.length > 0) {
        return "error";
      } else {
        if (match && match.match_confirmed && Object.keys(diff).length === 0) {
          return "confirmed_match";
        } else if (arr && arr.length > 0 && diffData && Object.keys(diffData).length > 0) {
          return "outdated";
        } else if (arr && arr.length === 0) {
          return "not_allowed";
        } else if (arr && arr.length > 1) {
          return "multiple";
        } else if (arr && arr.length === 1 && Object.keys(diff).length === 0) {
          if (arr[0].probable_match) {
            return "unconfirmed_match";
          } else {
            return "confirmed_match";
          }
        } else {
          return "";
        }
      }
    } else {
      return "";
    }
  };

  const returnTooltip = () => {
    if (allRecordsWithApiNameError && allRecordsWithApiNameError.length > 0) {
      return "There is an error with your CRM connection. Click to learn more";
    } else if (
      allRecordsWithApiName &&
      allRecordsWithApiName.length > 0 &&
      diffData &&
      Object.keys(diffData).length > 0
    ) {
      return "Record details in CRM are outdated. Click to learn more";
    } else if (allRecordsWithApiName && allRecordsWithApiName.length > 1) {
      return "Multiple matching records found. Click to learn more";
    } else {
      return "";
    }
  };

  const ref = useClickAway(() => {
    if (editMode || updateMode) {
      return;
    }
    setToggleDropdown(false);
  });

  function capitalizeFirstLetter(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const [currentCRMObject, setCurrentCRMObject] = useState({});
  const getObjectByApiName = () => {
    if (objectApiName && crmObjectsConfig && crmObjectsConfig.length > 0) {
      const foundObj = crmObjectsConfig.find((obj) => objectApiName === obj.crm_object_api_name);
      setCurrentCRMObject(foundObj);
    }
  };
  useEffect(() => {
    getObjectByApiName();
    return () => {
      setCurrentCRMObject({});
    };
  }, [objectApiName, crmObjectsConfig?.length]);

  const hasCreatePermissionByType = (type) => {
    if (type && crmObjectsConfig && crmObjectsConfig.length > 0) {
      const filteredItems = crmObjectsConfig.filter((item) => item?.type === type);
      return filteredItems.some((item) => item?.permission?.create === true);
    }
  };

  const dropdownPosition = () => {
    if (contentPosition === "right") {
      return "right-0";
    }
    if (
      type === "company" &&
      !companyMiniView &&
      recordData &&
      recordData.name &&
      recordData.name.length &&
      recordData.name.length > 26
    ) {
      return "right-0";
    } else {
      return "left-0";
    }
  };

  const { isOpen, openModal, closeModal } = useModal();
  useEffect(() => {
    if (editMode || updateMode) {
      if (source === "app") {
        openModal();
        setToggleDropdown(false);
      }
    }
  }, [editMode, updateMode]);

  const handleCloseModal = () => {
    setCreateDirect(false);
    setEditMode(false);
    setUpdateMode(false);
    setToggleDropdown(false);
    closeModal();
  };

  const buildUpdatePayload = ({ type, recordData, objectApiName, convertedCRMObjectApiName, matchedObj }) => {
    const basePayload = {
      crm_object_api_name: convertedCRMObjectApiName || objectApiName,
      crm_record_id: matchedObj?.Id,
      type,
    };

    if (type === "company") {
      return {
        ...basePayload,
        organization_id: recordData?.id || recordData?.organization_id,
      };
    }

    if (type === "person") {
      const payload = {
        ...basePayload,
        person_id: recordData?.person_id,
      };

      if (recordData?.contact_id) {
        payload.contact_id = recordData.contact_id;
      }

      return payload;
    }

    return basePayload; // fallback in case type is unexpected
  };

  // useEffect(() => {
  //   if (createdContactId) {
  //     handleSearchCRMRecords(recordData?.name, activeCrm);
  //   }
  // }, [createdContactId]);

  return (
    <>
      <div className={className} ref={ref}>
        <TooltipWrapper content={returnTooltip()} contentClassName="w-[250px]">
          <Button
            variant="outline"
            onClick={() => {
              handleToggleDropdown();
              captureEvent(type === "company" ? "EXC_Company_CRMBtn" : "EXP_Person_CRMBtn", {
                match_state: returnEventState(
                  matchedObj,
                  diffData,
                  allRecordsWithApiName,
                  allRecordsWithApiNameError
                ),
              });
            }}
            className="px-3 rounded-lg"
          >
            {isCRMAnalyseLoading ||
            getCRMRecordsFn.isLoading ||
            (isBulkEnrichment && isCRMBulkSearchPending) ? (
              <>
                <div className="loader_circle inline-block mr-2"></div>
                CRM
              </>
            ) : (
              <>
                {matchedObj &&
                matchedObj.match_confirmed &&
                diffData &&
                Object.keys(diffData).length === 0 ? (
                  <>
                    <Image src="/images/ext/crm/matched.svg" className="mr-2 h-[16px] w-[16px] no-invert" />
                    CRM
                  </>
                ) : (
                  <>
                    {returnImgAndName(
                      matchedObj,
                      diffData,
                      allRecordsWithApiName,
                      allRecordsWithApiNameError
                    )}
                  </>
                )}
              </>
            )}
          </Button>
        </TooltipWrapper>
        {toggleDropdown && (
          <div
            className={`absolute crm__dropdown top-[43px] ${dropdownPosition()}  z-20 bg-background   rounded-xl p-4 w-[280px] animate__animated animate__fadeIn animate__faster`}
            style={{ boxShadow: "0px 1px 3px var(--gray-400)" }}
          >
            {isCRMAnalyseLoading ||
            getCRMRecordsFn.isLoading ||
            (isBulkEnrichment && isCRMBulkSearchPending) ? (
              <div>
                <Skeleton className="h-[40px] w-full mb-4" />
                <Skeleton className="h-[60px] w-full mb-2" />
                <Skeleton className="h-[60px] w-full mb-2" />
              </div>
            ) : (
              <>
                {allRecordsWithApiNameError && allRecordsWithApiNameError.length > 0 ? (
                  <div>
                    {allRecordsWithApiNameError.map((item, index) => (
                      <div className={`flex items-start space-x-2 ${index > 0 ? "pt-4 border-t mt-4" : ""}`}>
                        <Image
                          src="/images/ext/alert-error.svg"
                          width="30"
                          height="30"
                          className="no-invert"
                        />
                        <div className="space-y-3">
                          {/* <div>
                          <b className="block mb-0 text-[13px]">
                            CRM Object
                          </b>
                          <span className="text-[13px]">
                            {item?.crm_object_label}
                          </span>
                        </div>
                        <div>
                          <b className="block mb-0 text-[13px]">Error Type</b>{" "}
                          <span className="text-[13px]">
                            {item?.error?.type}
                          </span>
                        </div> */}
                          <div>
                            {/* <b className="block mb-0 text-[13px]">
                            Error Message
                          </b> */}
                            <span className="text-[13px] first-letter-uppercase pr-word-break">
                              {capitalizeFirstLetter(item?.error?.description)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {matchedObj && matchedObj.match_confirmed ? (
                      <div className="">
                        {diffData && Object.keys(diffData).length > 0 && (
                          <div className="mb-4">
                            {" "}
                            <p className="text-sm flex items-center space-x-2">
                              <Image className="no-invert" src="/images/ext/crm/outdated.svg" />
                              <span>CRM needs to be updated</span>
                            </p>
                            <div className="border-b border-border my-4"></div>
                          </div>
                        )}
                        {console.log("matchedObj record", { matchedObj, record })}
                        <CrmRecord
                          data={matchedObj}
                          record={record}
                          diffData={diffData}
                          apiName={convertedCRMObjectApiName ? convertedCRMObjectApiName : objectLabelName}
                          crmObjectsConfig={crmObjectsConfig}
                          type={type}
                          convertedCRMObjectApiName={convertedCRMObjectApiName}
                        />
                        {diffData && Object.keys(diffData).length > 0 && (
                          <>
                            {currentCRMObject && currentCRMObject.permission && (
                              <>
                                {currentCRMObject.permission.update ? (
                                  <div className="space-y-2 my-4">
                                    <button
                                      onClick={() => {
                                        setUpdateMode(true);
                                      }}
                                      className="text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-white bg-brand-600 dark:bg-brand-300 border border-brand-600 font-semibold"
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="mr-1.5"
                                      >
                                        <path
                                          d="M5.83333 16.6667V3.33337M5.83333 3.33337L2.5 6.66671M5.83333 3.33337L9.16667 6.66671M14.1667 16.6667V7.50004M14.1667 7.50004L10.8333 10.8334M14.1667 7.50004L17.5 10.8334"
                                          stroke="white"
                                          stroke-width="1.66667"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Update CRM record
                                    </button>
                                  </div>
                                ) : (
                                  <>
                                    {currentCRMObject.permission.create && (
                                      <div className="space-y-2 my-4">
                                        <button
                                          onClick={() => {
                                            setEditMode(true);
                                            setCreateDirect(true);
                                          }}
                                          className="text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-brand-600 bg-background border border-brand-300 font-semibold"
                                        >
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="mr-1.5"
                                          >
                                            <path
                                              d="M9.99984 4.16663V15.8333M4.1665 9.99996H15.8332"
                                              stroke="var(--brand-700)"
                                              stroke-width="1.66667"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                          Create new record
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                        <div className="space-y-2 mt-4">
                          <button
                            onClick={() => {
                              // !matchCompanyInCRMFn.isLoading &&
                              //   handleMatchCompanyInCRM(matchedObj?.Id, true);

                              setEditMode(true);
                              captureEvent("ECRM_EditMatchBtn", {
                                type: type,
                                match_state: returnEventState(
                                  matchedObj,
                                  diffData,
                                  allRecordsWithApiName,
                                  allRecordsWithApiNameError
                                ),
                              });
                            }}
                            className="flex w-full justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background  text-gray-600 px-4 py-2 h-9 rounded-[8px] font-semibold"
                          >
                            Edit match
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        {allRecordsWithApiName && allRecordsWithApiName.length > 0 ? (
                          <>
                            {allRecordsWithApiName.length === 1 ? (
                              <div className="">
                                <div className="">
                                  {!allRecordsWithApiName[0]?.match_confirmed && (
                                    <div className="mb-4">
                                      {" "}
                                      <p className="text-sm">
                                        The below record was matched from CRM. Do you want to confirm this
                                        match?
                                      </p>
                                      <div className="border-b border-border my-4"></div>
                                    </div>
                                  )}

                                  <div>
                                    <CrmRecord
                                      data={allRecordsWithApiName[0]}
                                      record={record}
                                      diffData={diffData}
                                      crmObjectsConfig={crmObjectsConfig}
                                      type={type}
                                      apiName={
                                        convertedCRMObjectApiName
                                          ? convertedCRMObjectApiName
                                          : objectLabelName
                                      }
                                      convertedCRMObjectApiName={convertedCRMObjectApiName}
                                    />
                                    {!allRecordsWithApiName[0]?.match_confirmed && (
                                      <div className="space-y-2 mt-4">
                                        <button
                                          onClick={() => {
                                            !matchCompanyInCRMFn.isLoading &&
                                              handleMatchCompanyInCRM(allRecordsWithApiName[0]?.Id);

                                            captureEvent("ECRM_ConfirmMatchBtn", {
                                              type: type,
                                            });
                                          }}
                                          className="flex w-full justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background border-brand-300 text-brand-700 px-4 py-2 h-9 rounded-[8px] font-semibold"
                                        >
                                          Confirm match{" "}
                                          {matchCompanyInCRMFn.isLoading &&
                                            currentRecordId === allRecordsWithApiName[0]?.Id && (
                                              <div className="loader_circle inline-block ml-2"></div>
                                            )}
                                        </button>
                                        <button
                                          onClick={() => {
                                            // !matchCompanyInCRMFn.isLoading &&
                                            //   handleMatchCompanyInCRM(
                                            //     allRecordsWithApiName[0]?.Id,
                                            //     true
                                            //   );

                                            setEditMode(true);
                                            captureEvent("ECRM_EditMatchBtn", {
                                              type: type,
                                              match_state: returnEventState(
                                                matchedObj,
                                                diffData,
                                                allRecordsWithApiName,
                                                allRecordsWithApiNameError
                                              ),
                                            });
                                          }}
                                          className="flex w-full justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background  text-gray-600 px-4 py-2 h-9 rounded-[8px] font-semibold"
                                        >
                                          Edit match
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <p className="text-sm">
                                  We found multiple matching records in your CRM. Choose the correct record or
                                  edit search criteria
                                </p>
                                <button
                                  onClick={() => {
                                    setEditMode(true);
                                    captureEvent("ECRM_ChooseMatchingRecord", {
                                      type: type,
                                    });
                                  }}
                                  className="mt-4 text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-white bg-brand-600  dark:bg-brand-300 border border-brand-600 font-semibold"
                                >
                                  <span>Choose matching record</span>
                                </button>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {allRecordsWithApiName && allRecordsWithApiName.length === 0 && activeCrm ? (
                              <div>
                                <p className="text-sm">
                                  This {type === "company" ? "company" : "person"} doesn’t exist in your CRM
                                  or we couldn’t find a match.
                                </p>
                                <div className="flex space-x-2">
                                  {hasCreatePermissionByType(type) && (
                                    <button
                                      onClick={() => {
                                        setEditMode(true);
                                        setCreateDirect(true);
                                        captureEvent("ECRM_CreateRecordBtn", {
                                          type: type,
                                        });
                                      }}
                                      className="mt-4 text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-1 rounded-[8px] text-white bg-brand-600 dark:bg-brand-300 border border-brand-600 font-semibold"
                                    >
                                      <span>Create Record</span>
                                    </button>
                                  )}
                                  <button
                                    onClick={() => {
                                      setEditMode(true);
                                      captureEvent("ECRM_FindAMatchBtn", {
                                        type: type,
                                      });
                                    }}
                                    className="mt-4 text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-1 rounded-[8px] text-brand-600 bg-background border border-brand-600 font-semibold"
                                  >
                                    <span>Find a Match</span>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <Intro
                                installedCrm={installedCrm}
                                activeWorkspace={activeWorkspace}
                                activeCrm={activeCrm}
                                enabledCRMIntegrations={enabledCRMIntegrations}
                              />
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        )}

        {updateMode && source !== "app" && (
          <div className="fixed left-0 top-0 w-full h-screen bg-background z-50 m-0 overflow-y-scroll">
            <UpdateRecord
              closeModal={() => {
                setUpdateMode(false);
                setToggleDropdown(false);
              }}
              record={record}
              diffData={diffData}
              activeWorkspace={activeWorkspace}
              activeCrm={activeCrm}
              payload={buildUpdatePayload({
                type,
                recordData,
                objectApiName,
                convertedCRMObjectApiName,
                matchedObj,
              })}
              onSuccess={() => {
                handleSearchCRMRecords(recordData?.name, activeCrm);
              }}
            />
          </div>
        )}
        {editMode && source !== "app" && (
          <div className="fixed left-0 top-0 w-full h-screen bg-background z-50 m-0 overflow-y-scroll">
            <EditMatch
              type={type}
              closeModal={() => {
                setEditMode(false);
                setCreateDirect(false);
                setToggleDropdown(false);
              }}
              filters={filters}
              submitFilter={(searchFilters) => {
                handleSearchCRMRecords(recordData?.name, activeCrm, searchFilters);
              }}
              isLoading={isCRMBulkSearchLoading || matchCompanyInCRMFn.isLoading}
              records={records}
              objectWithSearchFilters={objectWithSearchFilters}
              objectApiName={objectApiName}
              resetFetchedRecordObj={(keyName) => {
                setFetchedRecordObj({
                  ...objectWithSearchFilters?.[keyName]?.search_filters_applied,
                });
              }}
              allRecords={allRecordsWithApiName}
              matchRecord={(apiName, id) => {
                handleMatchCompanyInCRM(id, false, apiName);
                setEditMode(false);
              }}
              fetchedRecordObj={fetchedRecordObj ? fetchedRecordObj : {}}
              fetchedReferences={fetchedReferences}
              createRecordData={{
                activeCrm: activeCrm,
                record_id: recordData?.id,
                crm_object_api_name: objectApiName,
                crm_object_api_label: objectLabelName ? objectLabelName : "",
                type: type,
                activeWorkspaceId: activeWorkspace?.id,
                company: recordData?.company,
                company_linkedin_url: recordData?.company_linkedin_url
                  ? recordData?.company_linkedin_url
                  : params?.company_url,
                contact_id: recordData?.contact_id,
                person_id: recordData?.person_id,
                organization_id: recordData?.organization_id,
              }}
              recordCreated={(contactId) => {
                console.log("contact_idcontact_idcontact_id !app");
                handleSearchCRMRecords(recordData?.name, activeCrm, null, contactId);
                const newevent = new CustomEvent("person_record_created", {
                  detail: true,
                });
                window.dispatchEvent(newevent);
              }}
              createDirect={createDirect}
              crmObjectsConfig={crmObjectsConfig}
              contactRevealed={contactRevealed}
            />
            {/* when contact api does not return current company linkedin url, then linkedin url is pulled from ref string */}
          </div>
        )}
        {updateMode && source === "app" && (
          <GenericModal isOpen={isOpen} closeModal={handleCloseModal}>
            <div className="overflow-y-scroll max-h-[80vh] -m-5">
              <UpdateRecord
                closeModal={() => {
                  handleCloseModal();
                }}
                record={record}
                diffData={diffData}
                activeWorkspace={activeWorkspace}
                activeCrm={activeCrm}
                payload={{
                  record_id: recordData?.id,
                  crm_object_api_name: convertedCRMObjectApiName ? convertedCRMObjectApiName : objectApiName,
                  crm_record_id: matchedObj?.Id,
                }}
                onSuccess={() => {
                  handleSearchCRMRecords(recordData?.name, activeCrm);
                }}
                source="app"
              />
            </div>
          </GenericModal>
        )}
        {editMode && source === "app" && (
          <GenericModal isOpen={isOpen} closeModal={handleCloseModal}>
            <div className="overflow-y-scroll max-h-[80vh] -m-5">
              <EditMatch
                type={type}
                closeModal={() => {
                  handleCloseModal();
                }}
                filters={filters}
                submitFilter={(searchFilters) => {
                  handleSearchCRMRecords(recordData?.name, activeCrm, searchFilters);
                }}
                isLoading={isCRMBulkSearchLoading || matchCompanyInCRMFn.isLoading}
                records={records}
                objectWithSearchFilters={objectWithSearchFilters}
                objectApiName={objectApiName}
                resetFetchedRecordObj={(keyName) => {
                  setFetchedRecordObj({
                    ...objectWithSearchFilters?.[keyName]?.search_filters_applied,
                  });
                }}
                allRecords={allRecordsWithApiName}
                matchRecord={(apiName, id) => {
                  handleMatchCompanyInCRM(id, false, apiName);
                  setEditMode(false);
                }}
                fetchedRecordObj={fetchedRecordObj ? fetchedRecordObj : {}}
                fetchedReferences={fetchedReferences}
                createRecordData={{
                  activeCrm: activeCrm,
                  record_id: recordData?.id,
                  crm_object_api_name: objectApiName,
                  crm_object_api_label: objectLabelName ? objectLabelName : "",
                  type: type,
                  activeWorkspaceId: activeWorkspace?.id,
                  company: recordData?.company,
                  company_linkedin_url: recordData?.company_linkedin_url
                    ? recordData?.company_linkedin_url
                    : params?.company_url,
                  organization_id: recordData?.organization_id,
                }}
                recordCreated={(contactId) => {
                  console.log("contact_idcontact_idcontact_id");
                  const newevent = new CustomEvent("person_record_created", {
                    detail: true,
                  });
                  window.dispatchEvent(newevent);
                  handleSearchCRMRecords(recordData?.name, activeCrm, null, contactId);
                }}
                createDirect={createDirect}
                crmObjectsConfig={crmObjectsConfig}
                contactRevealed={contactRevealed}
                source="app"
              />
            </div>
          </GenericModal>
        )}
      </div>
      {toggleDropdown && <div className="bg__overlay"></div>}
    </>
  );
}
